export const workData = [
    {
        img: "img/fashionapp.png",
        name: "Fashion App",
        url: "https://nnadidanfashionapp.netlify.app",
        desc: "Fashion app was created to help bridge the gap between consumers and retailers of clothing wares in the textile industry.",
        summary: "built with mern stack(Mongodb, React, Node.js)",
    },
    {
        img: "adminanalytics_nnadidan.png",
        name: "Admin Analytics",
        url: "https://adminanalyticsdashboard.netlify.app/",
        desc: "Admin Analytics dashboard is a dashboard that was created for the purpose of data visibility and insight.",
        summary: "built with mern stack(Mongodb, React, Node.js)",
    },
    {
        img: "img/tap_home.PNG",
        name: "Web Chat App",
        url: "https://tapchat-app.netlify.app",
        desc: "Tap Chat is an online SPA(single page Application) built to foster instant messaging and communication",
        summary: "built with MERN stack(Mongodb, Express, React, Node.js)"
    },
    
]


export const secondWorkData = [
    {
        img: "img/prime.jpg",
        name: "Crypto Trading App",
        url: "https://prime-minners-nnadidaniel.koyeb.app",
        desc: "Prime Minners is a simple crypto trading app that allows users to invest in crypto currencies all from the comfort of a dashboard ",
        summary: "built with python(Django)"
    },
    {
        img: "img/food.png",
        name: "Food Ordering App",
        url: "https://nnadidanfoodorderingapp.netlify.app/",
        desc: "Food Ordering app is an app built to bridge the gap between food vendors and consumers.",
        summary: "built with Django-React(React.js on the frontend and DjangoRestFramework on the backend)",
    },
]
